export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles['main-ui-block'])+'"></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/main-ui-block/templates/mainUIBlock.dot
// module id = 165
// module chunks = 0 1 2 3 4